import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class NavigationService {
    // Subject para comunicar eventos de navegação para projetos
    private collapseMenuSubject = new Subject<boolean>();
    public collapseMenu$ = this.collapseMenuSubject.asObservable();

    constructor(
        private router: Router,
        private location: Location,
    ) {}

    public goTo(url: string) {
        this.router.navigateByUrl(url);
    }

    public goToContextual(targetRoute: string) {
        // Detecta se estamos no contexto v2 ou v1
        const currentUrl = this.router.url;

        // Separar a rota base dos queryParams se existirem
        const [baseRoute, queryString] = targetRoute.split('?');
        const queryParams = queryString ? `?${queryString}` : '';

        if (currentUrl.startsWith('/v2/')) {
            // Contexto V2 - navegar para a estrutura v2
            if (baseRoute === 'ratoeiras') {
                // Verificar se a currentUrl vem da tela de ratoeiras
                if (currentUrl.includes('/v2/ratoeiras/')) {
                    this.router.navigateByUrl(`/v2/ratoeiras${queryParams}`);
                } else {
                    // Se estiver dentro de um projeto, extrair projetoId da URL
                    const match = currentUrl.match(/\/v2\/projetos\/(\d+)/);
                    const projetoId = match ? match[1] : null;
                    if (projetoId) {
                        this.router.navigateByUrl(`/v2/projetos/${projetoId}/ratoeiras${queryParams}`);
                    } else {
                        // Fallback para lista global de ratoeiras
                        this.router.navigateByUrl(`/v2/ratoeiras${queryParams}`);
                    }
                }
            } else if (baseRoute === 'link-visita') {
                // No V2, retornar para a lista de Ratoeiras
                if (currentUrl.includes('/v2/ratoeiras/')) {
                    this.router.navigateByUrl(`/v2/ratoeiras${queryParams}`);
                } else {
                    const match = currentUrl.match(/\/v2\/projetos\/(\d+)/);
                    const projetoId = match ? match[1] : null;
                    if (projetoId) {
                        this.router.navigateByUrl(`/v2/projetos/${projetoId}/ratoeiras${queryParams}`);
                    } else {
                        this.router.navigateByUrl(`/v2/ratoeiras${queryParams}`);
                    }
                }
            } else if (baseRoute === 'projetos') {
                // No V2, voltar para a lista de projetos.
                // Se a origem for ratoeiras globais, voltar para a Home V2.
                if (currentUrl.includes('/v2/ratoeiras')) {
                    this.router.navigateByUrl('/v2/painel');
                } else {
                    this.triggerMenuCollapse(false);
                    this.router.navigateByUrl(`/v2/projetos${queryParams}`);
                }
            } else if (baseRoute === 'url-venda') {
                // Navegação contextual para URL de venda no V2
                const match = currentUrl.match(/\/v2\/projetos\/(\d+)/);
                const projetoId = match ? match[1] : null;
                if (projetoId) {
                    this.router.navigateByUrl(`/v2/projetos/${projetoId}/url-venda${queryParams}`);
                } else {
                    // Fallback: se não estiver em um projeto, ir para a área de projetos
                    this.router.navigateByUrl('/v2/projetos');
                }
            } else if (baseRoute === 'notificacoes-venda') {
                const match = currentUrl.match(/\/v2\/projetos\/(\d+)/);
                const projetoId = match ? match[1] : null;
                if (projetoId) {
                    this.router.navigateByUrl(`/v2/projetos/${projetoId}/link-notificacao${queryParams}`);
                } else {
                    this.router.navigateByUrl(`/v2/notificacoes/link-notificacao${queryParams}`);
                }
            } else if (baseRoute.startsWith('checkout/link-checkout/')) {
                // Rotas específicas de checkout - manter estrutura v2
                this.router.navigateByUrl(`/v2/${targetRoute}`);
            } else if (baseRoute === 'link-checkout') {
                const match = currentUrl.match(/\/v2\/projetos\/(\d+)/);
                const projetoId = match ? match[1] : null;
                if (projetoId) {
                    this.router.navigateByUrl(`/v2/projetos/${projetoId}/link-checkout${queryParams}`);
                } else {
                    this.router.navigateByUrl(`/v2/checkout/link-checkout${queryParams}`);
                }
            } else if (baseRoute === 'apikey') {
                // Rota base de checkout - navegar para v2
                this.router.navigateByUrl('/v2/integracoes/apikey');
            } else if (baseRoute === '') {
                // Para rota vazia, navegar para a tela inicial v2
                this.router.navigateByUrl('/v2');
            } else {
                // Para outras rotas, manter a estrutura v2
                this.router.navigateByUrl(`/v2/${targetRoute}`);
            }
            // TODO: V1 code - Desativado temporariamente para uso exclusivo da V2
            // } else {
            //     // Contexto V1 - navegar para a estrutura v1
            //     if (baseRoute === 'ratoeiras') {
            //         this.router.navigateByUrl(`/ratoeira${queryParams}`);
            //
            //     } else if (baseRoute === 'projetos') {
            //         // No V1 não há área de projetos, voltar para o painel
            //         this.router.navigateByUrl('/painel');
            //
            //     } else if (baseRoute === 'url-venda') {
            //         // No V1, a rota de URL de venda fica fora da área de projetos
            //         this.router.navigateByUrl(`/url-venda${queryParams}`);
            //
            //     } else if (baseRoute === 'notificacoes-venda') {
            //         this.router.navigateByUrl('/notificacoes-venda');
            //
            //     } else if (baseRoute.startsWith('checkout/link-checkout/')) {
            //         // Rotas específicas de checkout - converter para estrutura v1
            //         // De: checkout/link-checkout/123/checkouts
            //         // Para: /link-checkout/123/checkouts
            //         const checkoutRoute = baseRoute.replace('checkout/', '');
            //         this.router.navigateByUrl(`/${checkoutRoute}${queryParams}`);
            //
            //     } else if (baseRoute === 'link-checkout') {
            //         // Rota base de checkout - navegar para v1
            //         this.router.navigateByUrl('/link-checkout');
            //
            //     } else if (baseRoute === '') {
            //         // Para rota vazia, navegar para a tela inicial v1
            //         this.router.navigateByUrl('/');
            //
            //     } else {
            //         // Para outras rotas, navegar diretamente
            //         this.router.navigateByUrl(`/${targetRoute}`);
            //
            //     }
        }
    }

    /**
     * Navega para a tela de visitas de uma ratoeira, respeitando o contexto V1/V2.
     * - V1: '/link-visita/:linkId/visitas'
     * - V2 (lista global): '/v2/ratoeiras/:shieldId/:linkId/visitas'
     * - V2 (dentro de projeto): '/v2/projetos/:projetoId/ratoeiras/:shieldId/:linkId/visitas'
     */
    public goToShieldVisitas(shieldId: number, linkVisitaConfigurationId: number): void {
        const currentUrl = this.router.url;

        // TODO: V1 code - Adaptação temporária para forçar V2 mesmo se não começar com /v2
        // if (currentUrl.startsWith('/v2/')) {
        const match = currentUrl.match(/\/v2\/projetos\/(\d+)/);
        const projetoId = match ? match[1] : null;

        if (projetoId) {
            this.router.navigateByUrl(
                `/v2/projetos/${projetoId}/ratoeiras/${shieldId}/${linkVisitaConfigurationId}/visitas`,
            );
        } else {
            this.router.navigateByUrl(`/v2/ratoeiras/${shieldId}/${linkVisitaConfigurationId}/visitas`);
        }
        // TODO: V1 code - Desativado temporariamente para uso exclusivo da V2
        // } else {
        //     this.router.navigateByUrl(`/link-visita/${linkVisitaConfigurationId}/visitas`);
        // }
    }

    goBack(): void {
        // Usar Location.back() para navegação simples e eficiente
        this.location.back();
    }

    // Método para disparar o recolhimento do menu quando navegar para projetos
    triggerMenuCollapse(collapse = true): void {
        this.collapseMenuSubject.next(collapse);
    }

    // Método para navegar para projeto e recolher o menu automaticamente
    goToProjetoAndCollapse(route: string, collapse = true): void {
        // Disparar o evento de recolhimento ANTES da navegação
        this.triggerMenuCollapse(collapse);

        // Pequeno delay para garantir que o evento seja processado antes da navegação
        setTimeout(() => {
            this.router.navigate([route]);
        }, 10);
    }

    /**
     * Abre uma URL externa em nova aba ou na mesma aba
     * @param url - URL completa para abrir
     * @param target - Target do link (_blank por padrão)
     */
    public openExternalUrl(url: string, target: string = '_blank'): void {
        window.open(url, target);
    }
}
